export enum ModuleUserCategory {
    UPCOMING = 'upcoming',
    ENDED = 'ended',
    RUNNING = 'running',
}
